._text_1r3cf_1 {
  color: var(--text-color) !important; }

@container chat (max-width: 470px) {
  ._text_1r3cf_1 {
    font-size: var(--text-font-size-slim) !important;
    line-height: var(--text-line-height-slim) !important; } }
